import React, { Fragment, useState } from 'react'
import { compact } from 'lodash'
import Table from 'UI/Table'
import DisableColumns from './DisableColumns'
import { clusterColumns as clusterColumnsDefault, nodesColumns, chartColumns } from './Columns'
import { TrendsChart } from 'Components/Chart'

const CloudianCapacityReport = ({ clusters, trends }) => {
  const [clusterColumns, filterColumns] = useState(clusterColumnsDefault)

  return (
    <Fragment>
      <DisableColumns
        columns={clusterColumnsDefault}
        disableColumns={(columns) => filterColumns(columns)}
      />
      <Table
        {...{
          data: clusters,
          columns: compact(clusterColumns),
          SubComponent: ({ original: cluster }) => (
            <Table
              {...{
                columns: nodesColumns,
                data: cluster.nodes,
                showPagination: false,
              }}
            />
          ),
        }}
      />
      <TrendsChart trends={trends} chartColumns={chartColumns} />
    </Fragment>
  );
}

export default CloudianCapacityReport
